import { useFocusedMeetingAPI, useMeetingSelector } from "../../../../hooks/meeting";

import { useStudentContext } from "../context";

import { MeetingRoomHighlightingState, MeetingRoomStatus, MeetingSessionHighlightingState } from "@kalyzee/kast-web-sdk/websocket";

import styles from "./dashboard.module.css";
import { RemotesToExpertsContainer } from "../../../../components/player/container/RemotesToExpertsContainer";
import { useMemo } from "react";

import "./dashboard.css"

export const MeetingHighlightStudentPage = () => {
  const studentCtx = useStudentContext();
  const meetingCtx = useFocusedMeetingAPI();
  const [session] = useMeetingSelector(meetingCtx, (state) => state.session);

  // ---------------------------------------------------------------------- //
  // ---------------------------   EFFECT ----------------------------- //
  // ---------------------------------------------------------------------- //

  const self = useMemo(() => {
    if (!session) return undefined;
    const highlightView = studentCtx?.availableViews?.find((view) => view.type === "highlight");
    const mySessionData = highlightView?.students.find((s) => s.video && s.session.id === session.id);
    if (!mySessionData) return undefined;
    // do NOT add self if not in rooms 
    if (mySessionData.session.user.group?.room.status === MeetingRoomStatus.Ongoing) {
      // only if is my group
      if (mySessionData.session.user.group?.room.highlighting !== MeetingRoomHighlightingState.ONGOING) return undefined;
    }
    return {
      present: !!(
        studentCtx?.selfVideoStream 
        && session?.highlighting === MeetingSessionHighlightingState.ONGOING
      ),
      videoStream: session?.highlighting === MeetingSessionHighlightingState.ONGOING ? studentCtx?.selfVideoStream : undefined,
      screens: true,
    };
  }, [studentCtx?.selfVideoStream, session, studentCtx?.availableViews]);

  // ---------------------------------------------------------------------- //
  // ---------------------------   RENDER ----------------------------- //
  // ---------------------------------------------------------------------- //

  if (!studentCtx) return null;

  const { currentView, layout } = studentCtx;

  if (currentView?.type !== "highlight") return null;

  return (
    <div className={styles.container}>
      <RemotesToExpertsContainer
        remoteSessions={currentView.students.filter(data => data.video).map(data => data.session)}
        expertSessions={currentView.experts.filter(data => data.video).map(data => data.session)}
        self={self}
        layout={layout}
      />
    </div>
  );
};
